/* eslint-disable no-unused-vars */
import { createSlice } from '@reduxjs/toolkit';

const initialFormErrorsSettingsState = {
  general: false,
  company: false,
};

const FormErrorsSettingsSlice = createSlice({
  name: 'formErrorsSettings',
  initialState: initialFormErrorsSettingsState,
  reducers: {
    updateErrorField: (state, action) => {
      const errorField = action.payload.errorField;
      state[errorField] = action.payload.newValue;
    },
    resetErrors: (state) => {
      for (const field in state) {
        if (state[field]) state[field] = false;
      }
    },
  },
});

export const formErrorsSettings_action = FormErrorsSettingsSlice.actions;
export default FormErrorsSettingsSlice.reducer;
